import { CCol, CFooter, CLink, CRow } from "@coreui/react";
import { Avatar } from "@material-ui/core";
import React from "react";
import MentoringClub from "../../assets/images/mentoring.jpeg";
import linkedin from "../../assets/images/linkedin.jpg";
import github from "../../assets/images/github.png";
import "../../assets/css/footer.css";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  large: {
    width: theme.spacing(4.5),
    height: theme.spacing(4.5),
  },
}));

export default function Footer() {
  const classes = useStyles();
  const handleClick = (x) => {
    window.open(x);
  };
  return (
    <div className="footer">
      <CFooter style={{ width: "100%", borderTop: "none" }}>
        <CRow className="align-items-center text-center">
          <CCol sm={6} xs={12}>
            <div className="autos">
              <span>
                &copy; Copyright 2023. Made by <CLink href="/">Mohanraj</CLink>
              </span>
            </div>
          </CCol>
          <CCol sm={6} xs={12}>
            <div className="mid autos justify-content-center">
              <Avatar
                onClick={() =>
                  handleClick(
                    "https://www.mentoring-club.com/the-mentors/mohanraj-murugasen"
                  )
                }
                alt="Remy Sharp"
                src={MentoringClub}
                className={classes.large}
              />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <Avatar
                onClick={() =>
                  handleClick("https://github.com/murugesanmohanraj")
                }
                alt="Travis Howard"
                src={github}
                className={classes.large}
              />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <Avatar
                onClick={() =>
                  handleClick("https://www.linkedin.com/in/murugesanmohanraj")
                }
                alt="Cindy Baker"
                src={linkedin}
                className={classes.large}
              />
            </div>
          </CCol>
        </CRow>
      </CFooter>
    </div>
  );
}
